//имя файла с сервера
export default function downloadFile(response, fileName){
	if (window.navigator && window.navigator.msSaveOrOpenBlob){
		// IE variant
		window.navigator.msSaveOrOpenBlob(new Blob([response], { type: response.type }), fileName)
	}
	else {
		const blob = new Blob([response], { type: response.type })
		const url = window.URL.createObjectURL(blob)
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("download", fileName)
		document.body.appendChild(link)
		link.click()
		link.remove()
	}
	return true
}
